<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else>
    <div class="row">
      <div class="col-4">
        <BrandDropdown
          v-model="brandSelected"
          @setBrand="setBrand"
        ></BrandDropdown>
      </div>
    </div>
    <div class="mt-3">
      <div class="row">
        <div class="d-flex align-items-center justify-content-start col">
          <span style="margin-right: 1rem">Show</span>
          <b-form-select
            class="form-control"
            style="width: 20%"
            v-model="perPage"
            :options="pageOptions"
            @change="onChangeEntries"
          ></b-form-select>
          <span style="margin-left: 1rem">entries</span>
        </div>
        <div class="d-flex align-items-center justify-content-end col">
          <label for="searchText" class="mx-3">Search: </label>
          <input
            id="searchText"
            type="text"
            v-model="searchText"
            class="form-control w-50"
            @change="getList"
          />
        </div>
      </div>

      <b-table
        class="table table-responsive table-bordered mt-5"
        hover
        responsive
        :fields="fields"
        :items="listProducts"
        :per-page="perPage"
        @sort-changed="sortCompare"
      >
        <template #cell(action)="data">
          <div class="d-flex justify-content-evenly">
            <router-link
              :to="{
                name: 'DetailProductMaster',
                query: { id: data.item.productCode },
              }"
              class="btn btn-outline-primary"
              >Detail</router-link
            >
          </div>
        </template>
      </b-table>
      <b-pagination
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
        class="my-0"
        aria-controls="my-table"
        @input="changePage"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import ProductService from "@/services/api/product.service";
import BrandDropdown from "components/Brand/BrandDropdown";
import DefaultListViewData from "@/views/defaultListViewData";
import fields from "./listProductFields.json";
export default {
  components: {
    BrandDropdown,
  },
  data() {
    return {
      ...DefaultListViewData,
      listProducts: [],
      fields,
    };
  },
  mounted() {
    this.isLoading = true;
    this.getList(this.sort);
  },
  methods: {
    async getList(sort) {
      try {
        const param = {
          currentPage: this.currentPage,
          limit: this.perPage,
          brand: this.brandSelected?.id,
          sortColumn: sort.key || "id",
          sortType: sort.type || "desc",
          key: this.searchText,
        };
        await ProductService.getListProducts(param)
          .then((res) => {
            const data = res.data;
            this.totalItems = data.totalItems;
            this.listProducts = data.product;
            this.isLoading = false;
          })
          .catch((err) => {
            console.log("Error: ", err);
            this.isLoading = false;
          });
      } catch (error) {
        console.log("Error: ", error);
        this.isLoading = false;
      }
    },
    setBrand(brand) {
      this.brandSelected = brand || "";
      this.getList(this.sort);
    },
    changePage() {
      this.getList(this.sort);
    },
    onChangeEntries() {
      this.getList(this.sort);
    },
    sortCompare(e) {
      let sortBy = e.sortBy;
      if (sortBy === "productCode") {
        sortBy = "parentCode";
      } else if (sortBy === "productName") {
        sortBy = "name";
      }
      this.sort = {
        key: sortBy,
        type: e.sortDesc ? "desc" : "asc",
      };
      this.getList(this.sort);
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  margin: 1rem 0;
}
.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}
.btn-del {
  color: red;

  .btn-del:hover {
    color: white;
  }
}
.content-dialog {
  height: 300px;
  background: #fff;

  h3 {
    text-align: center;
    padding: 5rem 0 2rem;
  }

  .btn-back {
    border: 1px solid #1976d2;
    width: 28%;
    height: 39px;
    border-radius: 25px;
    color: #1976d2;
  }
  .btn-back:hover {
    text-decoration: underline;
  }
}
</style>
